import { createPortal } from "react-dom";
import { CSSTransition } from "react-transition-group";
import { useClickOutside } from "@mantine/hooks";
import styles from "./styles/ModalWrapper.module.scss";
// Utils
import icons from "../../../utils/icons";

const ModalWrapper = ({
  children,
  displayStatus,
  toggle,
  className,
  title,
}) => {
  const ref = useClickOutside(() => toggle(false));

  return createPortal(
    <CSSTransition
      in={displayStatus}
      timeout={500}
      unmountOnExit
      classNames={{
        enter: styles.open,
        exit: styles.closed,
      }}
    >
      <div className={styles["modal-wrapper"]}>
        <div className={`${styles.modal} ${className}`} ref={ref}>
          {title && (
            <div className={styles.title}>
              <p>{title}</p>
              <button type={"button"} onClick={() => toggle(false)}>
                {icons.cross}
              </button>
            </div>
          )}

          {children}
        </div>
      </div>
    </CSSTransition>,
    document.getElementById("modal")
  );
};

export default ModalWrapper;
